import { useState, useCallback } from 'react';
const useSnackbar = () => {
  const [snackbarVisible, setSnackbarVisible] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarDuration, setSnackbarDuration] = useState(3000);
  const [snackColor, setSnackColor] = useState("success");

  

  const openSnackbar = useCallback(({message, duration = 3000,color="success"}) => {
    setSnackbarMessage(message);
    setSnackbarDuration(duration);
    setSnackColor(color);
    setSnackbarVisible(true);
  }, []);

  const closeSnackbar = useCallback(() => {
    setSnackbarVisible(false);
  }, []);

  return {
    snackbarVisible,
    snackbarMessage,
    snackbarDuration,
    openSnackbar,
    closeSnackbar,
    snackColor
  };
};

export default useSnackbar;
